import styled, { css } from 'styled-components'

import { mq, sizes } from '../../theme'

export const Button = styled.button<{
  isActive?: boolean
  isLongText?: boolean
}>`
  display: inline-block;
  position: relative;
  flex-direction: column;
  justify-content: center;
  border-radius: 2.8rem;
  padding: 1.25rem 0.5rem;
  align-items: center;
  width: auto;
  min-width: 5rem;
  border: 1px solid ${({ theme }) => theme.colors.pureBlack};
  outline: 0 none;
  border-color: ${({ theme }) => theme.colors.pureBlack};
  color: ${({ theme }) => theme.colors.pureBlack};
  background-color: ${({ theme }) => theme.colors.pureWhite};
  transition: color 150ms ease-in-out, border-color 150ms ease-in-out,
    background-color 150ms ease-in-out;
  cursor: pointer;

  ${({ isActive, theme }) =>
    isActive &&
    css`
      background: ${theme.colors.greenEmerald};
      border-color: ${({ theme }) => theme.colors.greenEmerald};
    `}
  ${({ isLongText }) =>
    isLongText &&
    css`
      min-width: min-content;
    `}

  &:disabled {
    box-shadow: 0 none;
    opacity: 0.5;
    cursor: not-allowed;
  }

  @media ${mq(sizes.desktop)} {
    min-width: 14rem;
    padding: 0.75rem 2.75rem;
    border-radius: 2.8rem;

    &:hover:not(:disabled) {
      color: ${({ theme }) => theme.colors.pureBlack};
      background-color: ${({ theme }) => theme.colors.greenMint};
    }
  }
`

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
`

export const Text = styled.span`
  ${({ theme }) => theme.textStyles.text_bold_condensed_12};
  justify-content: center;
`

export const TextDesktop = styled(Text)`
  display: none;

  @media ${mq(sizes.desktop)} {
    display: flex;
  }
`
export const TextMobile = styled(Text)`
  display: flex;

  @media ${mq(sizes.desktop)} {
    display: none;
  }
`

export const Number = styled.span`
  ${({ theme }) => theme.textStyles.text_16};

  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.text_14};
  }
`
